var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElipseDemo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 1118,
    viewBox: "0 0 636 1118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.7795,
    cy: 558.779,
    r: 395.5,
    transform: "rotate(41.1725 76.7795 558.779)",
    stroke: "#EEEEEE",
    strokeOpacity: 0.07
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.7795,
    cy: 558.779,
    r: 326.5,
    transform: "rotate(41.1725 76.7795 558.779)",
    stroke: "#EEEEEE",
    strokeOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.7795,
    cy: 558.779,
    r: 249.5,
    transform: "rotate(41.1725 76.7795 558.779)",
    stroke: "#EEEEEE",
    strokeOpacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.028,
    cy: 686.818,
    r: 7,
    transform: "rotate(41.1725 451.028 686.818)",
    fill: "#BBBBBB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 449.086,
    cy: 424.734,
    r: 7,
    transform: "rotate(41.1725 449.086 424.734)",
    fill: "#2D2D2D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.396,
    cy: 312.207,
    r: 4,
    transform: "rotate(41.1725 118.396 312.207)",
    fill: "#2D2D2D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.3283,
    cy: 233.202,
    r: 7,
    transform: "rotate(41.1725 49.3283 233.202)",
    fill: "#2D2D2D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipseDemo);
export default __webpack_public_path__ + "static/media/Elipse-demo.4fece707381e181146df1bf99f96f493.svg";
export { ForwardRef as ReactComponent };